/* eslint-disable no-unused-vars */
/* eslint-disable max-lines */

import React, {
 useContext, useEffect, useState
} from 'react';
import CreateApp from 'builders/builderApp/CreateApp';
import {
 Context
} from 'shared/context/GlobalState';
import {
 Button
} from 'shared/components/ui/button';
import {
 applicationService
} from 'shared/api/services/BEXO';
import AlertModal from 'shared/components/Alertmodal';
import {
 useParams
} from 'react-router-dom';
import {
  PageContent,
  PageContentHeader,
  PageContentHeaderText,
  PageContentHeaderTitle,
  PageDescription,
  PageHeader,
  PageHeaderAction,
  PageLayout,
  PageSubTitle,
  PageTitle,
  PageTitles,
} from 'shared/components/NewDesignComponents/PageLayout';
import AppCard from 'builders/builderApp/AppCard';
import SearchItems from 'shared/components/NewDesignComponents/SearchItems';
import {
 FilterBar
} from 'builders/builderApp/AppFilters';
import ApplicationUpdate from 'builders/builderApp/AppUpdate';
// import {
//  OrganizationContext
// } from 'shared/context/OrganizationContext';
import {
 Application
} from '../types/builderApp.types';

export default function AppBuilderPage() {
  const instructionTypes = [
    {
      name: 'All',
      value: 'All',
    },
    {
      name: 'Active',
      value: 'Active',
    },
    {
      name: 'Inactive',
      value: 'Inactive',
    },
  ];

  const [application, setApplication] = useState<Application[]>([]);
  const [applicationDialog, setApplicationDialog] = useState(false);
  const [loading, setLoading] = useState(true);
  const [filteredApplication, setFilteredApplication] = useState<Application[]>(
    [],
  );
  const [selectType, setSelectType] = useState('All');
  const [updateModal, setUpdateModal] = useState(false);
  const [delModal, setDelModal] = useState(false);
  const [delBtn, setDelBtn] = useState(false);
  const [selectedCard, setSelectedCard] = useState<Application | null>(null);

  const {
 oragID
} = useParams<{ oragID: string }>();
  const {
 addNewNotifcation
} = useContext(Context);
  //   const {
  //  selectedOrganization
  // } = useContext(OrganizationContext);

  useEffect(() => {
    fetchApplication();
  }, [oragID]);

  const fetchApplication = async () => {
    setApplication([]);
    setLoading(true);

    try {
      const res = await applicationService.listApplication(oragID);

      if (Array.isArray(res.data)) {
        const applications = res.data.map((item) => ({
          ...item,
          appId: item.app_id,
        }));

        setFilteredApplication(applications);
        setApplication(applications);
      } else {
        console.error('Unexpected response format:', res.data);
        setApplication([]);
        setFilteredApplication([]);
      }
    } catch (error) {
      console.error('Error fetching applications:', error);
    } finally {
      setLoading(false);
    }
  };

  // const handleDeleteApplication = async () => {
  //   if (!selectedCard || !selectedCard.name) {
  //     console.error('No application selected for deletion.');
  //     addNewNotifcation('Error: No application selected', 'danger');
  //     return;
  //   }

  //   setDelBtn(true);
  //   try {
  //     const Appdata = await applicationService.getApplication(oragID, selectedCard.app_id);
  //     await applicationService.deleteApplication(Appdata.organization_slug, selectedCard.name);
  //     setApplication((prev) => prev.filter((item) => item.name !== selectedCard.name));
  //     addNewNotifcation('App deleted successfully', 'success');
  //     setDelModal(false);
  //     setSelectedCard(null);
  //   } catch (error) {
  //     console.error('Delete failed:', error);
  //     addNewNotifcation('Something went wrong', 'danger');
  //   } finally {
  //     setDelBtn(false);
  //   }
  // };
  const handleDeleteApplication = async () => {
    if (!selectedCard || !selectedCard.name) {
      console.error('No application selected for deletion.');
      addNewNotifcation('Error: No application selected', 'danger');
      return;
    }

    setDelBtn(true);
    try {
      const Appdata = await applicationService.getApplication(
        oragID,
        selectedCard.app_id,
      );

      // Type guard to check if Appdata is of type ApplicationDetails
      if ('organization_slug' in Appdata) {
        await applicationService.deleteApplication(
          Appdata.organization_slug,
          selectedCard.name,
        );
        setApplication((prev) =>
          prev.filter((item) => item.name !== selectedCard.name),
        );
        addNewNotifcation('App deleted successfully', 'success');
        setDelModal(false);
        setSelectedCard(null);
      } else {
        // Handle error if Appdata is an ErrorResponse
        console.error('Error fetching application data:', Appdata);
        addNewNotifcation(
          'Something went wrong while fetching application details',
          'danger',
        );
      }
    } catch (error) {
      console.error('Delete failed:', error);
      addNewNotifcation('Something went wrong', 'danger');
    } finally {
      setDelBtn(false);
    }
  };

  const handleFilterApplication = (searchTerm: string) => {
    let filteredItems = application;

    // Apply Search Filter
    if (searchTerm) {
      filteredItems = filteredItems.filter((app) =>
        app.name.toLowerCase().includes(searchTerm.toLowerCase()),
      );
    }

    // Apply Active/Inactive Filter
    if (selectType !== 'All') {
      filteredItems = filteredItems.filter(
        (app) =>
          (selectType === 'Active' && app.active === true) ||
          (selectType === 'Inactive' && app.active === false),
      );
    }

    setFilteredApplication(filteredItems);
  };

  useEffect(() => {
    handleFilterApplication('');
  }, [selectType, application]);

  return (
      <PageLayout>
          <PageHeader>
              <PageTitles>
                  <PageTitle>App Builder</PageTitle>
                  <PageSubTitle>Build Your Digital Future</PageSubTitle>
                  <PageDescription>
                      Create and manage powerful applications with our comprehensive
                      builder suite. Design data structures, craft 3D experiences, and
                      bring your vision to life with tools designed for modern development
                      needs.
                  </PageDescription>
              </PageTitles>
              <PageHeaderAction>
                  <Button onClick={() => setApplicationDialog(true)} className="w-full">
                      Create New App
                  </Button>
              </PageHeaderAction>
          </PageHeader>

          <PageContent loading={loading}>
              <PageContentHeader>
                  <PageContentHeaderTitle>App Builder:</PageContentHeaderTitle>
                  <PageContentHeaderText>
                      Manage your Applications
                  </PageContentHeaderText>
              </PageContentHeader>

              <div className="w-full mx-auto p-2 md:p-6">
                  <div className="space-y-4">
                      <div className="mb-6 flex flex-col sm:flex-row gap-4 items-center">
                          <div className="flex-grow">
                              <SearchItems
                  items={application}
                  handleFilterItems={handleFilterApplication}
                  placeholder="Search Apps..."
                />
                          </div>
                          <FilterBar
                placeholder="Filter App type"
                types={instructionTypes}
                allListings={application}
                setListings={setFilteredApplication}
                selectType={selectType}
                setSelectType={setSelectType}
              />
                      </div>

                      {loading ? (
                          <div className="flex flex-grow justify-center items-center">
                              <span className="text-lg font-semibold mb-2">
                                  Loading Applications...
                              </span>
                          </div>
            ) : filteredApplication.length > 0 ? (
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                    {filteredApplication.map((app) => (
                        <AppCard
                    key={app.app_id}
                    application={app}
                    onDelete={() => {
                      setSelectedCard(app);
                      setDelModal(true);
                    }}
                  />
                ))}
                </div>
            ) : (
                <div className="flex flex-grow justify-center items-center">
                    <span className="text-lg font-semibold mb-2">
                        No Apps Found
                    </span>
                </div>
            )}
                  </div>
              </div>

              <CreateApp
          isOpen={applicationDialog}
          setOpenApplicationModal={setApplicationDialog}
          oragID={oragID}
          fetchApplication={fetchApplication}
        />

              <ApplicationUpdate
          isOpen={updateModal}
          setOpenApplicationModal={setUpdateModal}
          application={selectedCard || null}
          setApplication={setApplication}
        />
              <AlertModal
          loading={delBtn}
          openModal={delModal}
          setopenModal={setDelModal}
          onDelete={handleDeleteApplication}
        />
          </PageContent>
      </PageLayout>
  );
}
